import React from 'react';

export const AboutPage: React.FC = () => {
  return (
    <div className="container-app py-8">
      <h1 className="mb-6">О нас</h1>
      <div className="card mb-6">
        <h3 className="mb-4">Restaurant Orders</h3>
        <p className="text-text-secondary mb-4">
          Современная система управления заказами для ресторанов. Мы предоставляем
          удобный интерфейс для приёма и обработки заказов, управления меню и
          отслеживания статусов.
        </p>
        <p className="text-text-secondary">
          Наша цель - сделать процесс работы с заказами максимально простым и эффективным.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="card text-center">
          <div className="w-16 h-16 bg-primary-500 rounded-lg flex items-center justify-center mx-auto mb-4">
            <span className="text-white text-2xl">⚡</span>
          </div>
          <h4 className="mb-2">Быстро</h4>
          <p className="text-text-secondary text-sm">
            Обработка заказов в режиме реального времени
          </p>
        </div>

        <div className="card text-center">
          <div className="w-16 h-16 bg-success-500 rounded-lg flex items-center justify-center mx-auto mb-4">
            <span className="text-white text-2xl">🎯</span>
          </div>
          <h4 className="mb-2">Удобно</h4>
          <p className="text-text-secondary text-sm">
            Интуитивно понятный интерфейс для всех устройств
          </p>
        </div>

        <div className="card text-center">
          <div className="w-16 h-16 bg-accent-500 rounded-lg flex items-center justify-center mx-auto mb-4">
            <span className="text-white text-2xl">🔒</span>
          </div>
          <h4 className="mb-2">Надёжно</h4>
          <p className="text-text-secondary text-sm">
            Безопасное хранение данных и защита информации
          </p>
        </div>
      </div>
    </div>
  );
};
